/**
 * Cives Hub Backend Authentication API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { PlatformActionType } from './platform-action-type';


export interface AccountResendEmailForm { 
    action: PlatformActionType;
    /**
     * Email dell\'utente di destinazione. Non puo\' essere nullo o vuoto.
     */
    email: string;
}



